import { LimitBaseInput } from './types';

export const getTransactionConfiguration = (values: LimitBaseInput) => ({
  inTransactionAwardCount: {
    limit: values.limit,
  },
});
